import { ratesObserv } from './app/calculation/observers';
import { multiGroupObserver } from './app/registry/observers';

export default [
  ratesObserv,
  multiGroupObserver,
];
